import Vue from 'vue';
import VueRouter from 'vue-router';

import Menu from './components/Menu';
import Main from './components/Main';
import Wallets from './components/Wallets';
import Period from './components/Period';
import Wallet from './components/Wallet';
import Wishlist from './components/Wishlist';
import Setting from './components/Setting';

Vue.use(VueRouter);

const router = new VueRouter({
    routes: [
        {
            path: '/',
            components: {
                menu: Menu,
                main: Main
            }
        },
        {
            path: '/wallets',
            components: {
                menu: Menu,
                main: Wallets
            },
            children: [
                {
                    path: '',
                    components: {
                        left: Period
                    }
                }
            ]
        },
        {
            path: '/:year/:month',
            components: {
                menu: Menu,
                main: Wallets
            },
            children: [
                {
                    path: '',
                    name: 'wallet',
                    components: {
                        left: Period,
                        right: Wallet
                    },
                    props: { left: false, right: true }
                }
            ]
        },
        {
            path: '/wishlist',
            name: 'wishlist',
            components: {
                menu: Menu,
                main: Wishlist
            }
        },
        {
            path: '/setting',
            name: 'setting',
            components: {
                menu: Menu,
                main: Setting
            }
        }
    ]
});

export default router;